/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  AvailablePhoneNumbersResponse,
  BodyOrganizationAssignPhoneNumberToCampaign,
  BodyOrganizationCreateOrganizationBrand,
  BodyOrganizationPurchasePhoneNumber,
  BodyOrganizationTestPhoneNumberCall,
  BodyOrganizationTestPhoneNumberSms,
  BodyOrganizationUpdateOrganizationBrand,
  BodyOrganizationUpdatePhoneNumberTestedStatus,
  CreateAddressRequest,
  DeleteBrandPayload,
  EmbeddedSignupCompletion,
  EmbeddedSignupOtpResponse,
  EmbeddedSignupPublicConfig,
  MessageResponse,
  OrgPhoneNumbersResponse,
  OrgTestCallResponse,
  OrgUiLanguageResponse,
  OrganizationBrandResponse,
  OrganizationDeleteWhatsappEmbeddedSignupSessionParams,
  OrganizationGetWhatsappEmbeddedSignupOtpParams,
  OrganizationListTwilioAddressesParams,
  OrganizationResponse,
  OrganizationSearchAvailablePhoneNumbersParams,
  PermanentPhoneNumbersResponse,
  PhoneNumberAssignmentResponse,
  PhoneNumberPurchaseResponse,
  PhoneNumberReleaseResponse,
  PhoneNumberSuggestion,
  PhoneNumberTestedUpdateResponse,
  PhonePurchaseOptionsResponse,
  SetDefaultBrandPayload,
  StartEmbeddedSignupSessionPayload,
  TelnyxCampaignCapacity,
  TestSmsResponse,
  TwilioAddressResponse,
  TwilioAddressesResponse,
  TwilioMessagingCapacity,
  UpdateOrgUiLanguagePayload,
  UpdateOrganizationPayload,
  UpdateWhatsAppAutoRegistrationPayload,
  WhatsAppApprovalResponse,
  WhatsAppAutoRegistrationResponse,
  WhatsAppSenderRegistrationPayload,
  WhatsAppSenderRegistrationResponse,
  WhatsAppSenderResponse,
  WhatsAppSenderStatusResponse,
  WhatsAppSenderVerificationPayload,
  WhatsAppSendersResponse,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getOrganization = () => {
  /**
   * Get organization information for the authenticated user's org.
   * @summary Get Organization
   */
  const organizationGetOrganization = (
    options?: SecondParameter<typeof axiosInstance<OrganizationResponse>>
  ) => {
    return axiosInstance<OrganizationResponse>(
      { url: `/organization`, method: 'POST' },
      options
    );
  };
  /**
   * Update organization information (admins only).
   * @summary Update Organization
   */
  const organizationUpdateOrganization = (
    updateOrganizationPayload: UpdateOrganizationPayload,
    options?: SecondParameter<typeof axiosInstance<OrganizationResponse>>
  ) => {
    return axiosInstance<OrganizationResponse>(
      {
        url: `/organization`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateOrganizationPayload,
      },
      options
    );
  };
  /**
   * Set the organization's default recruiter app language (admins only).
   * @summary Update Ui Language
   */
  const organizationUpdateUiLanguage = (
    updateOrgUiLanguagePayload: UpdateOrgUiLanguagePayload,
    options?: SecondParameter<typeof axiosInstance<OrgUiLanguageResponse>>
  ) => {
    return axiosInstance<OrgUiLanguageResponse>(
      {
        url: `/organization/ui_language`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateOrgUiLanguagePayload,
      },
      options
    );
  };
  /**
   * Get all brands for an organization.
   * @summary Get Organization Brands
   */
  const organizationGetOrganizationBrands = (
    options?: SecondParameter<typeof axiosInstance<OrganizationBrandResponse[]>>
  ) => {
    return axiosInstance<OrganizationBrandResponse[]>(
      { url: `/organization/brands`, method: 'POST' },
      options
    );
  };
  /**
   * Create a new organization brand (admins only).
   * @summary Create Organization Brand
   */
  const organizationCreateOrganizationBrand = (
    bodyOrganizationCreateOrganizationBrand: BodyOrganizationCreateOrganizationBrand,
    options?: SecondParameter<typeof axiosInstance<OrganizationBrandResponse>>
  ) => {
    const formData = new FormData();
    formData.append(
      `brand_name`,
      bodyOrganizationCreateOrganizationBrand.brand_name
    );
    if (bodyOrganizationCreateOrganizationBrand.is_default !== undefined) {
      formData.append(
        `is_default`,
        bodyOrganizationCreateOrganizationBrand.is_default.toString()
      );
    }
    if (
      bodyOrganizationCreateOrganizationBrand.logo !== undefined &&
      bodyOrganizationCreateOrganizationBrand.logo !== null
    ) {
      formData.append(`logo`, bodyOrganizationCreateOrganizationBrand.logo);
    }

    return axiosInstance<OrganizationBrandResponse>(
      {
        url: `/organization/brands/create`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
   * Update an organization brand (admins only).
   * @summary Update Organization Brand
   */
  const organizationUpdateOrganizationBrand = (
    bodyOrganizationUpdateOrganizationBrand: BodyOrganizationUpdateOrganizationBrand,
    options?: SecondParameter<typeof axiosInstance<OrganizationBrandResponse>>
  ) => {
    const formData = new FormData();
    formData.append(
      `brand_id`,
      bodyOrganizationUpdateOrganizationBrand.brand_id
    );
    formData.append(
      `brand_name`,
      bodyOrganizationUpdateOrganizationBrand.brand_name
    );
    if (bodyOrganizationUpdateOrganizationBrand.is_default !== undefined) {
      formData.append(
        `is_default`,
        bodyOrganizationUpdateOrganizationBrand.is_default.toString()
      );
    }
    if (
      bodyOrganizationUpdateOrganizationBrand.logo !== undefined &&
      bodyOrganizationUpdateOrganizationBrand.logo !== null
    ) {
      formData.append(`logo`, bodyOrganizationUpdateOrganizationBrand.logo);
    }
    if (bodyOrganizationUpdateOrganizationBrand.delete_logo !== undefined) {
      formData.append(
        `delete_logo`,
        bodyOrganizationUpdateOrganizationBrand.delete_logo.toString()
      );
    }

    return axiosInstance<OrganizationBrandResponse>(
      {
        url: `/organization/brands/update`,
        method: 'PUT',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
   * Delete an organization brand (admins only).
   * @summary Delete Organization Brand
   */
  const organizationDeleteOrganizationBrand = (
    deleteBrandPayload: DeleteBrandPayload,
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      {
        url: `/organization/brands/delete`,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        data: deleteBrandPayload,
      },
      options
    );
  };
  /**
   * Set a brand as the default for the organization (admins only).
   * @summary Set Default Brand
   */
  const organizationSetDefaultBrand = (
    setDefaultBrandPayload: SetDefaultBrandPayload,
    options?: SecondParameter<typeof axiosInstance<OrganizationBrandResponse>>
  ) => {
    return axiosInstance<OrganizationBrandResponse>(
      {
        url: `/organization/brands/set-default`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: setDefaultBrandPayload,
      },
      options
    );
  };
  /**
   * @summary Get Phone Number Purchase Options
   */
  const organizationGetPhoneNumberPurchaseOptions = (
    orgId: string,
    options?: SecondParameter<
      typeof axiosInstance<PhonePurchaseOptionsResponse>
    >
  ) => {
    return axiosInstance<PhonePurchaseOptionsResponse>(
      { url: `/org/${orgId}/phone-numbers/purchase-options`, method: 'GET' },
      options
    );
  };
  /**
   * Search for available phone numbers from Twilio or Telnyx
   * @summary Search Available Phone Numbers
   */
  const organizationSearchAvailablePhoneNumbers = (
    orgId: string,
    params?: OrganizationSearchAvailablePhoneNumbersParams,
    options?: SecondParameter<
      typeof axiosInstance<AvailablePhoneNumbersResponse>
    >
  ) => {
    return axiosInstance<AvailablePhoneNumbersResponse>(
      { url: `/org/${orgId}/phone-numbers/search`, method: 'GET', params },
      options
    );
  };
  /**
 * How full the 10DLC campaign this org's next Telnyx purchase would use already is.

Advisory only — the buy UI uses it to disable Telnyx when there is no slot left to assign the
number to. Always answers 200: an unreadable count comes back as `lookup_failed` so the caller
fails open rather than blocking a purchase Telnyx might well accept.
 * @summary Get Telnyx 10Dlc Capacity
 */
  const organizationGetTelnyx10dlcCapacity = (
    orgId: string,
    options?: SecondParameter<typeof axiosInstance<TelnyxCampaignCapacity>>
  ) => {
    return axiosInstance<TelnyxCampaignCapacity>(
      {
        url: `/org/${orgId}/phone-numbers/telnyx-10dlc-capacity`,
        method: 'GET',
      },
      options
    );
  };
  /**
 * How full the Twilio messaging services a US purchase registers on already are.

Advisory only — the buy UI uses it to disable Twilio when no configured service can take
another sender. Always answers 200: an unreadable count comes back as `lookup_failed` so
the caller fails open rather than blocking a purchase Twilio might well accept.
 * @summary Get Twilio Messaging Capacity
 */
  const organizationGetTwilioMessagingCapacity = (
    orgId: string,
    options?: SecondParameter<typeof axiosInstance<TwilioMessagingCapacity>>
  ) => {
    return axiosInstance<TwilioMessagingCapacity>(
      {
        url: `/org/${orgId}/phone-numbers/twilio-messaging-capacity`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * List registered addresses in the Twilio account.
   * @summary List Twilio Addresses
   */
  const organizationListTwilioAddresses = (
    orgId: string,
    params?: OrganizationListTwilioAddressesParams,
    options?: SecondParameter<typeof axiosInstance<TwilioAddressesResponse>>
  ) => {
    return axiosInstance<TwilioAddressesResponse>(
      { url: `/org/${orgId}/phone-numbers/addresses`, method: 'GET', params },
      options
    );
  };
  /**
   * Create a new address in Twilio for regulatory compliance.
   * @summary Create Twilio Address
   */
  const organizationCreateTwilioAddress = (
    orgId: string,
    createAddressRequest: CreateAddressRequest,
    options?: SecondParameter<typeof axiosInstance<TwilioAddressResponse>>
  ) => {
    return axiosInstance<TwilioAddressResponse>(
      {
        url: `/org/${orgId}/phone-numbers/addresses`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createAddressRequest,
      },
      options
    );
  };
  /**
 * Purchase a phone number from Twilio or Telnyx and configure it automatically

Args:
    org_id: Organization ID
    phone_number: Phone number to purchase in E.164 format
    permanent_number_only: If True, marks this number for permanent campaigns only
    campaign_id: If provided, assigns this phone number to the specified campaign
    provider: Provider to purchase from (twilio or telnyx)
 * @summary Purchase Phone Number
 */
  const organizationPurchasePhoneNumber = (
    orgId: string,
    bodyOrganizationPurchasePhoneNumber: BodyOrganizationPurchasePhoneNumber,
    options?: SecondParameter<typeof axiosInstance<PhoneNumberPurchaseResponse>>
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `phone_number`,
      bodyOrganizationPurchasePhoneNumber.phone_number
    );
    if (
      bodyOrganizationPurchasePhoneNumber.purchase_option_id !== undefined &&
      bodyOrganizationPurchasePhoneNumber.purchase_option_id !== null
    ) {
      formUrlEncoded.append(
        `purchase_option_id`,
        bodyOrganizationPurchasePhoneNumber.purchase_option_id
      );
    }
    if (
      bodyOrganizationPurchasePhoneNumber.permanent_number_only !== undefined
    ) {
      formUrlEncoded.append(
        `permanent_number_only`,
        bodyOrganizationPurchasePhoneNumber.permanent_number_only.toString()
      );
    }
    if (
      bodyOrganizationPurchasePhoneNumber.campaign_id !== undefined &&
      bodyOrganizationPurchasePhoneNumber.campaign_id !== null
    ) {
      formUrlEncoded.append(
        `campaign_id`,
        bodyOrganizationPurchasePhoneNumber.campaign_id
      );
    }
    if (
      bodyOrganizationPurchasePhoneNumber.address_sid !== undefined &&
      bodyOrganizationPurchasePhoneNumber.address_sid !== null
    ) {
      formUrlEncoded.append(
        `address_sid`,
        bodyOrganizationPurchasePhoneNumber.address_sid
      );
    }
    if (
      bodyOrganizationPurchasePhoneNumber.bundle_sid !== undefined &&
      bodyOrganizationPurchasePhoneNumber.bundle_sid !== null
    ) {
      formUrlEncoded.append(
        `bundle_sid`,
        bodyOrganizationPurchasePhoneNumber.bundle_sid
      );
    }
    if (bodyOrganizationPurchasePhoneNumber.provider !== undefined) {
      formUrlEncoded.append(
        `provider`,
        bodyOrganizationPurchasePhoneNumber.provider
      );
    }

    return axiosInstance<PhoneNumberPurchaseResponse>(
      {
        url: `/org/${orgId}/phone-numbers/purchase`,
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      },
      options
    );
  };
  /**
   * Get all phone numbers associated with an organization
   * @summary Get Org Phone Numbers
   */
  const organizationGetOrgPhoneNumbers = (
    orgId: string,
    options?: SecondParameter<typeof axiosInstance<OrgPhoneNumbersResponse>>
  ) => {
    return axiosInstance<OrgPhoneNumbersResponse>(
      { url: `/org/${orgId}/phone-numbers`, method: 'GET' },
      options
    );
  };
  /**
   * Get permanent-number-only phone numbers with campaign assignment status
   * @summary Get Permanent Phone Numbers
   */
  const organizationGetPermanentPhoneNumbers = (
    orgId: string,
    options?: SecondParameter<
      typeof axiosInstance<PermanentPhoneNumbersResponse>
    >
  ) => {
    return axiosInstance<PermanentPhoneNumbersResponse>(
      { url: `/org/${orgId}/phone-numbers/permanent`, method: 'GET' },
      options
    );
  };
  /**
 * Suggest how many phone numbers the org needs based on peak daily outbound dial
volume over the trailing 14 days (target 150 calls per number per day).
 * @summary Get Phone Number Suggestion
 */
  const organizationGetPhoneNumberSuggestion = (
    orgId: string,
    options?: SecondParameter<typeof axiosInstance<PhoneNumberSuggestion>>
  ) => {
    return axiosInstance<PhoneNumberSuggestion>(
      { url: `/org/${orgId}/phone-numbers/suggested`, method: 'GET' },
      options
    );
  };
  /**
   * Assign a phone number to a campaign
   * @summary Assign Phone Number To Campaign
   */
  const organizationAssignPhoneNumberToCampaign = (
    orgId: string,
    phoneNumberId: string,
    bodyOrganizationAssignPhoneNumberToCampaign: BodyOrganizationAssignPhoneNumberToCampaign,
    options?: SecondParameter<
      typeof axiosInstance<PhoneNumberAssignmentResponse>
    >
  ) => {
    return axiosInstance<PhoneNumberAssignmentResponse>(
      {
        url: `/org/${orgId}/phone-numbers/${phoneNumberId}/assign-campaign`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bodyOrganizationAssignPhoneNumberToCampaign,
      },
      options
    );
  };
  /**
   * Unassign a phone number from its campaign (makes it available for other jobs).
   * @summary Unassign Phone Number From Campaign
   */
  const organizationUnassignPhoneNumberFromCampaign = (
    orgId: string,
    phoneNumberId: string,
    options?: SecondParameter<
      typeof axiosInstance<PhoneNumberAssignmentResponse>
    >
  ) => {
    return axiosInstance<PhoneNumberAssignmentResponse>(
      {
        url: `/org/${orgId}/phone-numbers/${phoneNumberId}/unassign-campaign`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * Test a phone number by making a call
   * @summary Test Phone Number Call
   */
  const organizationTestPhoneNumberCall = (
    orgId: string,
    bodyOrganizationTestPhoneNumberCall: BodyOrganizationTestPhoneNumberCall,
    options?: SecondParameter<typeof axiosInstance<OrgTestCallResponse>>
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `from_phone_number`,
      bodyOrganizationTestPhoneNumberCall.from_phone_number
    );
    formUrlEncoded.append(
      `to_phone_number`,
      bodyOrganizationTestPhoneNumberCall.to_phone_number
    );

    return axiosInstance<OrgTestCallResponse>(
      {
        url: `/org/${orgId}/phone-numbers/test-call`,
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      },
      options
    );
  };
  /**
   * Test a phone number by sending an SMS
   * @summary Test Phone Number Sms
   */
  const organizationTestPhoneNumberSms = (
    orgId: string,
    bodyOrganizationTestPhoneNumberSms: BodyOrganizationTestPhoneNumberSms,
    options?: SecondParameter<typeof axiosInstance<TestSmsResponse>>
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `from_phone_number`,
      bodyOrganizationTestPhoneNumberSms.from_phone_number
    );
    formUrlEncoded.append(
      `to_phone_number`,
      bodyOrganizationTestPhoneNumberSms.to_phone_number
    );
    if (bodyOrganizationTestPhoneNumberSms.message !== undefined) {
      formUrlEncoded.append(
        `message`,
        bodyOrganizationTestPhoneNumberSms.message
      );
    }

    return axiosInstance<TestSmsResponse>(
      {
        url: `/org/${orgId}/phone-numbers/test-sms`,
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      },
      options
    );
  };
  /**
   * Update the tested status of a phone number
   * @summary Update Phone Number Tested Status
   */
  const organizationUpdatePhoneNumberTestedStatus = (
    orgId: string,
    phoneNumber: string,
    bodyOrganizationUpdatePhoneNumberTestedStatus: BodyOrganizationUpdatePhoneNumberTestedStatus,
    options?: SecondParameter<
      typeof axiosInstance<PhoneNumberTestedUpdateResponse>
    >
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `tested`,
      bodyOrganizationUpdatePhoneNumberTestedStatus.tested.toString()
    );

    return axiosInstance<PhoneNumberTestedUpdateResponse>(
      {
        url: `/org/${orgId}/phone-numbers/${phoneNumber}/tested`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      },
      options
    );
  };
  /**
 * Retire a phone number locally, across every org holding it.

The number stops being selectable for new calls immediately. Handing it back to the
carrier is left to the daily provider-release sweep, which waits until the number has
gone unused, so an accidental release here stays recoverable.
 * @summary Release Phone Number
 */
  const organizationReleasePhoneNumber = (
    orgId: string,
    phoneNumber: string,
    options?: SecondParameter<typeof axiosInstance<PhoneNumberReleaseResponse>>
  ) => {
    return axiosInstance<PhoneNumberReleaseResponse>(
      {
        url: `/org/${orgId}/phone-numbers/${phoneNumber}/release`,
        method: 'POST',
      },
      options
    );
  };
  /**
 * Link an existing WhatsApp Business Account to an organization phone number.

Note: You must have an existing WhatsApp Business Account (WABA) created via
Twilio Console. This endpoint links your WABA to one of your organization's
phone numbers.
 * @summary Register Whatsapp Sender
 */
  const organizationRegisterWhatsappSender = (
    orgId: string,
    whatsAppSenderRegistrationPayload: WhatsAppSenderRegistrationPayload,
    options?: SecondParameter<
      typeof axiosInstance<WhatsAppSenderRegistrationResponse>
    >
  ) => {
    return axiosInstance<WhatsAppSenderRegistrationResponse>(
      {
        url: `/org/${orgId}/whatsapp-senders`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: whatsAppSenderRegistrationPayload,
      },
      options
    );
  };
  /**
   * Get all WhatsApp senders registered for the organization.
   * @summary Get Whatsapp Senders
   */
  const organizationGetWhatsappSenders = (
    orgId: string,
    options?: SecondParameter<typeof axiosInstance<WhatsAppSendersResponse>>
  ) => {
    return axiosInstance<WhatsAppSendersResponse>(
      { url: `/org/${orgId}/whatsapp-senders`, method: 'GET' },
      options
    );
  };
  /**
   * Submit verification code for a WhatsApp sender.
   * @summary Verify Whatsapp Sender
   */
  const organizationVerifyWhatsappSender = (
    orgId: string,
    senderSid: string,
    whatsAppSenderVerificationPayload: WhatsAppSenderVerificationPayload,
    options?: SecondParameter<typeof axiosInstance<WhatsAppSenderResponse>>
  ) => {
    return axiosInstance<WhatsAppSenderResponse>(
      {
        url: `/org/${orgId}/whatsapp-senders/${senderSid}/verify`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: whatsAppSenderVerificationPayload,
      },
      options
    );
  };
  /**
   * Get the current status of a WhatsApp sender from Twilio.
   * @summary Get Whatsapp Sender Status
   */
  const organizationGetWhatsappSenderStatus = (
    orgId: string,
    senderSid: string,
    options?: SecondParameter<
      typeof axiosInstance<WhatsAppSenderStatusResponse>
    >
  ) => {
    return axiosInstance<WhatsAppSenderStatusResponse>(
      {
        url: `/org/${orgId}/whatsapp-senders/${senderSid}/status`,
        method: 'GET',
      },
      options
    );
  };
  /**
 * Check if the organization has at least one approved WhatsApp sender.

This endpoint is used to conditionally show the WhatsApp option in Campaign Settings.
 * @summary Has Approved Whatsapp Sender
 */
  const organizationHasApprovedWhatsappSender = (
    orgId: string,
    options?: SecondParameter<typeof axiosInstance<WhatsAppApprovalResponse>>
  ) => {
    return axiosInstance<WhatsAppApprovalResponse>(
      { url: `/org/${orgId}/whatsapp-senders/has-approved`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Get Whatsapp Auto Registration
   */
  const organizationGetWhatsappAutoRegistration = (
    orgId: string,
    options?: SecondParameter<
      typeof axiosInstance<WhatsAppAutoRegistrationResponse>
    >
  ) => {
    return axiosInstance<WhatsAppAutoRegistrationResponse>(
      { url: `/org/${orgId}/whatsapp-auto-registration`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Update Whatsapp Auto Registration
   */
  const organizationUpdateWhatsappAutoRegistration = (
    orgId: string,
    updateWhatsAppAutoRegistrationPayload: UpdateWhatsAppAutoRegistrationPayload,
    options?: SecondParameter<
      typeof axiosInstance<WhatsAppAutoRegistrationResponse>
    >
  ) => {
    return axiosInstance<WhatsAppAutoRegistrationResponse>(
      {
        url: `/org/${orgId}/whatsapp-auto-registration`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateWhatsAppAutoRegistrationPayload,
      },
      options
    );
  };
  /**
   * Public Meta identifiers for the Login with Facebook button, or enabled=false.
   * @summary Get Whatsapp Embedded Signup Config
   */
  const organizationGetWhatsappEmbeddedSignupConfig = (
    orgId: string,
    options?: SecondParameter<typeof axiosInstance<EmbeddedSignupPublicConfig>>
  ) => {
    return axiosInstance<EmbeddedSignupPublicConfig>(
      { url: `/org/${orgId}/whatsapp-embedded-signup/config`, method: 'GET' },
      options
    );
  };
  /**
 * Open a short-lived session before the Facebook popup.

Meta texts the one-time code to the Twilio number. The inbound SMS webhook
stores it here so the recruiter can type it into the popup.
 * @summary Start Whatsapp Embedded Signup Session
 */
  const organizationStartWhatsappEmbeddedSignupSession = (
    orgId: string,
    startEmbeddedSignupSessionPayload: StartEmbeddedSignupSessionPayload,
    options?: SecondParameter<typeof axiosInstance<EmbeddedSignupOtpResponse>>
  ) => {
    return axiosInstance<EmbeddedSignupOtpResponse>(
      {
        url: `/org/${orgId}/whatsapp-embedded-signup/sessions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: startEmbeddedSignupSessionPayload,
      },
      options
    );
  };
  /**
   * Drop the session when the recruiter cancels, so later texts are not held.
   * @summary Delete Whatsapp Embedded Signup Session
   */
  const organizationDeleteWhatsappEmbeddedSignupSession = (
    orgId: string,
    params: OrganizationDeleteWhatsappEmbeddedSignupSessionParams,
    options?: SecondParameter<typeof axiosInstance<EmbeddedSignupOtpResponse>>
  ) => {
    return axiosInstance<EmbeddedSignupOtpResponse>(
      {
        url: `/org/${orgId}/whatsapp-embedded-signup/sessions`,
        method: 'DELETE',
        params,
      },
      options
    );
  };
  /**
   * Return Meta's code once the SMS webhook has stored it. Empty until then.
   * @summary Get Whatsapp Embedded Signup Otp
   */
  const organizationGetWhatsappEmbeddedSignupOtp = (
    orgId: string,
    params: OrganizationGetWhatsappEmbeddedSignupOtpParams,
    options?: SecondParameter<typeof axiosInstance<EmbeddedSignupOtpResponse>>
  ) => {
    return axiosInstance<EmbeddedSignupOtpResponse>(
      {
        url: `/org/${orgId}/whatsapp-embedded-signup/sessions/otp`,
        method: 'GET',
        params,
      },
      options
    );
  };
  /**
 * Register the sender after Embedded Signup finishes.

Uses the WABA id from Meta and the phone number collected before the popup.
Twilio credentials never leave the server.
 * @summary Complete Whatsapp Embedded Signup
 */
  const organizationCompleteWhatsappEmbeddedSignup = (
    orgId: string,
    embeddedSignupCompletion: EmbeddedSignupCompletion,
    options?: SecondParameter<
      typeof axiosInstance<WhatsAppSenderRegistrationResponse>
    >
  ) => {
    return axiosInstance<WhatsAppSenderRegistrationResponse>(
      {
        url: `/org/${orgId}/whatsapp-embedded-signup/complete`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: embeddedSignupCompletion,
      },
      options
    );
  };
  return {
    organizationGetOrganization,
    organizationUpdateOrganization,
    organizationUpdateUiLanguage,
    organizationGetOrganizationBrands,
    organizationCreateOrganizationBrand,
    organizationUpdateOrganizationBrand,
    organizationDeleteOrganizationBrand,
    organizationSetDefaultBrand,
    organizationGetPhoneNumberPurchaseOptions,
    organizationSearchAvailablePhoneNumbers,
    organizationGetTelnyx10dlcCapacity,
    organizationGetTwilioMessagingCapacity,
    organizationListTwilioAddresses,
    organizationCreateTwilioAddress,
    organizationPurchasePhoneNumber,
    organizationGetOrgPhoneNumbers,
    organizationGetPermanentPhoneNumbers,
    organizationGetPhoneNumberSuggestion,
    organizationAssignPhoneNumberToCampaign,
    organizationUnassignPhoneNumberFromCampaign,
    organizationTestPhoneNumberCall,
    organizationTestPhoneNumberSms,
    organizationUpdatePhoneNumberTestedStatus,
    organizationReleasePhoneNumber,
    organizationRegisterWhatsappSender,
    organizationGetWhatsappSenders,
    organizationVerifyWhatsappSender,
    organizationGetWhatsappSenderStatus,
    organizationHasApprovedWhatsappSender,
    organizationGetWhatsappAutoRegistration,
    organizationUpdateWhatsappAutoRegistration,
    organizationGetWhatsappEmbeddedSignupConfig,
    organizationStartWhatsappEmbeddedSignupSession,
    organizationDeleteWhatsappEmbeddedSignupSession,
    organizationGetWhatsappEmbeddedSignupOtp,
    organizationCompleteWhatsappEmbeddedSignup,
  };
};
export type OrganizationGetOrganizationResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationGetOrganization']
    >
  >
>;
export type OrganizationUpdateOrganizationResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationUpdateOrganization']
    >
  >
>;
export type OrganizationUpdateUiLanguageResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationUpdateUiLanguage']
    >
  >
>;
export type OrganizationGetOrganizationBrandsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationGetOrganizationBrands']
    >
  >
>;
export type OrganizationCreateOrganizationBrandResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationCreateOrganizationBrand']
    >
  >
>;
export type OrganizationUpdateOrganizationBrandResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationUpdateOrganizationBrand']
    >
  >
>;
export type OrganizationDeleteOrganizationBrandResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationDeleteOrganizationBrand']
    >
  >
>;
export type OrganizationSetDefaultBrandResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationSetDefaultBrand']
    >
  >
>;
export type OrganizationGetPhoneNumberPurchaseOptionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationGetPhoneNumberPurchaseOptions']
    >
  >
>;
export type OrganizationSearchAvailablePhoneNumbersResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationSearchAvailablePhoneNumbers']
    >
  >
>;
export type OrganizationGetTelnyx10dlcCapacityResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationGetTelnyx10dlcCapacity']
    >
  >
>;
export type OrganizationGetTwilioMessagingCapacityResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationGetTwilioMessagingCapacity']
    >
  >
>;
export type OrganizationListTwilioAddressesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationListTwilioAddresses']
    >
  >
>;
export type OrganizationCreateTwilioAddressResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationCreateTwilioAddress']
    >
  >
>;
export type OrganizationPurchasePhoneNumberResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationPurchasePhoneNumber']
    >
  >
>;
export type OrganizationGetOrgPhoneNumbersResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationGetOrgPhoneNumbers']
    >
  >
>;
export type OrganizationGetPermanentPhoneNumbersResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationGetPermanentPhoneNumbers']
    >
  >
>;
export type OrganizationGetPhoneNumberSuggestionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationGetPhoneNumberSuggestion']
    >
  >
>;
export type OrganizationAssignPhoneNumberToCampaignResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationAssignPhoneNumberToCampaign']
    >
  >
>;
export type OrganizationUnassignPhoneNumberFromCampaignResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationUnassignPhoneNumberFromCampaign']
    >
  >
>;
export type OrganizationTestPhoneNumberCallResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationTestPhoneNumberCall']
    >
  >
>;
export type OrganizationTestPhoneNumberSmsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationTestPhoneNumberSms']
    >
  >
>;
export type OrganizationUpdatePhoneNumberTestedStatusResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationUpdatePhoneNumberTestedStatus']
    >
  >
>;
export type OrganizationReleasePhoneNumberResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationReleasePhoneNumber']
    >
  >
>;
export type OrganizationRegisterWhatsappSenderResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationRegisterWhatsappSender']
    >
  >
>;
export type OrganizationGetWhatsappSendersResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationGetWhatsappSenders']
    >
  >
>;
export type OrganizationVerifyWhatsappSenderResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationVerifyWhatsappSender']
    >
  >
>;
export type OrganizationGetWhatsappSenderStatusResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getOrganization>['organizationGetWhatsappSenderStatus']
    >
  >
>;
export type OrganizationHasApprovedWhatsappSenderResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationHasApprovedWhatsappSender']
    >
  >
>;
export type OrganizationGetWhatsappAutoRegistrationResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationGetWhatsappAutoRegistration']
    >
  >
>;
export type OrganizationUpdateWhatsappAutoRegistrationResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationUpdateWhatsappAutoRegistration']
    >
  >
>;
export type OrganizationGetWhatsappEmbeddedSignupConfigResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationGetWhatsappEmbeddedSignupConfig']
    >
  >
>;
export type OrganizationStartWhatsappEmbeddedSignupSessionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationStartWhatsappEmbeddedSignupSession']
    >
  >
>;
export type OrganizationDeleteWhatsappEmbeddedSignupSessionResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationDeleteWhatsappEmbeddedSignupSession']
    >
  >
>;
export type OrganizationGetWhatsappEmbeddedSignupOtpResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationGetWhatsappEmbeddedSignupOtp']
    >
  >
>;
export type OrganizationCompleteWhatsappEmbeddedSignupResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getOrganization
      >['organizationCompleteWhatsappEmbeddedSignup']
    >
  >
>;
